export enum PageContentDisplayMode {
  Regular = 'Regular',
  SplitScreen = 'SplitScreen'
}
